export default {

  data: () => ({
    statuses: {
      1: {
        d: {
          text: "Rascunho",
          class: "badge-secondary",
          value: "0",
          successMessage : "Rascunho Salvo!"
        },

        p: {
          text: "Orçamento",
          class: "badge-primary",
          successMessage : "Orçamento Salvo!"
        },

        o: {
          text: "Venda",
          class: "badge-success",
          successMessage : "Venda Finalizada!"
        },

        c: {
          text: "Cancelada",
          class: "badge-danger",
        },
      },
      2: {
        d: {
          text: "Rascunho Devolução",
          class: "badge-danger",
          value: "0",
          successMessage : "Rascunho de devolução Salvo!"
        },

        o: {
          text: "Devolução",
          class: "badge-danger",
          successMessage : "Devolução Finalizada!"
        },

        c: {
          text: "Cancelada",
          class: "badge-danger",
        },
      },
    },
  }),

}